import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'

const CardListTab = ({ heading, items, hidden}) => (
	<article className="text-center" hidden={hidden}>
		<HTag className="h1" {...heading} />

		<ul className="flex justify-center flex-col md:flex-row mt-11 gap-14">
			{items?.map((program, key) => (
				<li data-aos="fade-down" data-aos-delay={key * 100} className="flex flex-col gap-2 md:w-[300px]" key={key}>
					<HTag className="h3 md:min-h-[60px]" {...program.heading} />
					<Richtext raw={program._rawRichtext} />
				</li>
			))}
		</ul>
	</article>
)

export default CardListTab
